import { defineMobileFormWindow } from "@app/overlay";
import {
    StockFinishedGoodsReceiptFilterForm,
    type StockFinishedGoodsReceiptFilterFormProps,
} from "./components/StockFinishedGoodsReceiptFilter/StockFinishedGoodsReceiptFilterForm";

/** Реестр overlay-окон списка ВЗН УП прихода на СГП. */
export const stockFinishedGoodsReceiptListWindows = {
    filter: defineMobileFormWindow<StockFinishedGoodsReceiptFilterFormProps>({
        key: "stock.finishedGoodsReceipt.filter",
        title: "Фильтр ВЗН УП приход на СГП",
        component: StockFinishedGoodsReceiptFilterForm,
    }),
};
